import { View, StyleSheet } from "react-native";
import { useToasts, useToast } from "../../contexts/ToastContext";
import Toast from "./Toast";

const ToastContainer = () => {
  const toasts = useToasts();
  const { hideToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <View style={styles.container} pointerEvents="box-none">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={hideToast} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "fixed",
    top: 16,
    left: 0,
    right: 0,
    alignItems: "center",
    zIndex: 9999,
    pointerEvents: "box-none",
  },
});

export default ToastContainer;
